import { useState } from 'react'
import Sidebar from './Sidebar'
import PageHeader from './PageHeader'

function DashboardLayout({ title, actions, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="dashboard">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <main className="main-content">
        <PageHeader
          title={title}
          actions={actions}
          onMenuClick={() => setSidebarOpen(true)}
        />

        <div className="page-body">
          {children}
        </div>
      </main>
    </div>
  )
}

export default DashboardLayout
